/* ready */
$(function() {
  'use strict';

  $('.p-members__slide').slick({
    dots: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    infinite: false,
    responsive: [
       {
        breakpoint: 768,
        settings: {
          slidesToShow:2
        }
       }
     ]
  });
});